/*
 * Formatação dos números de pesquisa de satisfação (NPS), compartilhada entre o relatório de
 * pesquisas de curso (ABRA-220) e o da pesquisa NPS de evento (ABRA-370).
 */

export const responsesLabel = (count: number) => `${count} ${count === 1 ? 'resposta' : 'respostas'}`

export const formatAverage = (average: number | null) =>
  average === null ? '—' : average.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 2 })

export const formatNpsScore = (score: number | null) =>
  score === null ? '—' : score.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

export const formatScore = (value: number | null) => (value === null ? '-' : value.toLocaleString('pt-BR'))

export const formatPercentage = (value: number) => value.toLocaleString('pt-BR', { maximumFractionDigits: 1 })

// Zonas usuais do NPS: crítica (< 0), aperfeiçoamento (0 a 49) e qualidade (>= 50).
export const npsColor = (score: number | null) => {
  if (score === null) return 'gray.400'
  if (score < 0) return 'red.500'
  if (score < 50) return 'orange.500'

  return 'green.500'
}
